import React from "react";
import MapTo from "../../utils/mapto";
import styled from "styled-components";

const StyledContainer = styled.div`
    background: ${props => props.backgroundColor || 'transparent'};
    box-shadow: ${props => props.backgroundShadow || 'none'};
`;

const StyledContent = styled.div`
    &.card2__content > div:first-child {
        background: ${props => {
            switch(props.contentfulId) {
                case 'soft-green':
                    return '#D5EBDB';
                case 'soft-green-2':
                    return '#E1E9DDB2';
                case 'soft-blue':
                    return '#DFEDF0';
                default:
                    return '#FBE1D0';
            }
        }};
    }
`;

const Card2 = (props) => {
    const items = props?.items || props?.content?.items;
    const backgroundColor = props.backgroundColor || (props.content && props.content.backgroundColor);
    const backgroundShadow = props.backgroundShadow || (props.content && props.content.backgroundShadow);
    const borderRadius = props.borderRadius || (props.content && props.content.borderRadius);
    const borderRadiusTop = props.borderRadiusTop || (props.content && props.content.borderRadiusTop);
    const borderRadiusBottom = props.borderRadiusBottom || (props.content && props.content.borderRadiusBottom);
    const contentfulId = props?.content?.contentfulid;

    const contentItems = items?.filter(item => 
        item.__typename !== "ContentfulMedia" && 
        !item.__typename?.toLowerCase().includes('cta')
    ) || [];

    return (
        <StyledContainer
            backgroundColor={backgroundColor}
            backgroundShadow={backgroundShadow}
            className={`card1 flex-1 flex justify-start ${borderRadius ? ` rounded-all_48` : ''}${borderRadiusTop ? ` rounded-top_48` : ''}${borderRadiusBottom ? ` rounded-bottom_48` : ''}`}
        >
            {contentItems.length > 0 && (
                <StyledContent 
                    contentfulId={contentfulId}
                    className="card2__content w-full text-center"
                >
                    <div className="[&>*:first-child]:mx-auto lg:[&>*:first-child]:max-w-[270px] [&>*:first-child]:pb-4 lg:px-14 px-6 py-6 lg:py-8 rounded-top_48 flex flex-col items-center">
                        {contentItems[0] && <MapTo key={contentItems[0].id} items={contentItems[0]} />}
                    </div>
                    <div className="py-6 lg:py-8 px-6 lg:px-14 flex flex-col items-center">
                        {contentItems.slice(1).map(item => (
                            <MapTo key={item.id} items={item} />
                        ))}
                    </div>
                    {items?.some(item => item.__typename?.toLowerCase().includes('cta')) && (
                        <div className="lg:mb-10 mb-8 flex justify-center items-center gap-4 flex-wrap px-6 lg:px-14">
                            <MapTo items={items} filter="cta" />
                        </div>
                    )}
                </StyledContent>
            )}
        </StyledContainer>
    );
};

export default Card2; 